import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import Label from '@kurtosys/ksys-app-components/dist/components/base/Label/Label';

export default InjectedStyledComponent(Label, 'forgotPassword', ['label']);